import script from "./LoadMoreButton.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadMoreButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__